import { defineComponent as e } from "vue";
import "./CouponPageNormal.css";
const t = e({
  name: "CouponPageNormal",
  components: {},
  props: {
    couponShowCaseList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    CopyCoupon(o) {
      window.CopyCouponCode(o);
    },
    CopyAndJump(o) {
      window.CopyCouponCode(o), setTimeout(() => {
        window.location.href = "/";
      }, 2e3);
    }
  }
});
export {
  t as default
};
